import { ArrowDownWideNarrow } from "lucide-react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "components/common/dropdown/DropDownV2";
import { cn } from "utils/cn";
import {
  COMMENT_PANEL_SORT_OPTIONS,
  PRIORITY_SORT_DESCRIPTION_WITHOUT_READ_STATUS,
} from "../commentPanelSort.constants";
import { isCommentPanelSortActive } from "../commentPanelSort.types";
import type { CommentPanelSort } from "../commentPanelSort.types";
import type { ScriptCommentsPanelSortMenuProps } from "./ScriptCommentsPanelSortMenu.types";

export const ScriptCommentsPanelSortMenu = ({
  sort,
  onSortChange,
  readStatusUnavailable = false,
}: ScriptCommentsPanelSortMenuProps) => {
  const sortActive = isCommentPanelSortActive(sort);

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="Sort comments"
          className={cn(
            "relative flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-muted-foreground transition hover:bg-muted hover:text-foreground",
            sortActive && "bg-muted/50 text-hue-sky"
          )}
        >
          <ArrowDownWideNarrow className="h-4 w-4" aria-hidden />
          {sortActive ? (
            <span
              className="absolute right-1.5 top-1.5 h-1.5 w-1.5 rounded-full bg-hue-sky"
              aria-hidden
            />
          ) : null}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        sideOffset={6}
        className="min-w-[13.5rem] max-w-[min(calc(100vw-2rem),18rem)]"
      >
        <DropdownMenuLabel className="text-xs uppercase tracking-wider text-muted-foreground">
          Sort by
        </DropdownMenuLabel>
        <DropdownMenuRadioGroup
          value={sort}
          onValueChange={(value) => onSortChange(value as CommentPanelSort)}
        >
          {COMMENT_PANEL_SORT_OPTIONS.map(({ value, label, description }) => (
            <DropdownMenuRadioItem key={value} value={value} className="items-start py-2">
              <div className="flex min-w-0 flex-col gap-0.5 pr-4">
                <span className="text-sm text-foreground">{label}</span>
                <span className="text-[11px] leading-snug text-muted-foreground">
                  {value === "priority" && readStatusUnavailable
                    ? PRIORITY_SORT_DESCRIPTION_WITHOUT_READ_STATUS
                    : description}
                </span>
              </div>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
